import React, { useEffect, useState } from 'react'
import Link from 'next/link'
import { Colors } from '@/constants/styles/color'
import CloseIcon from '@/assets/img/icons/Close_M.svg'
import HalfModal from '@/components/atoms/Dialog/HalfModal'
import { CvsResult } from '@/types/Purchase'
import { getCvsPurchaseInfo } from '@/pages/api/payment'

import {
  StyledArrowBackIcon,
  StyledCloseIcon,
  StyledCvsResultContainer,
  StyledCvsResultMessage,
  StyledCvsResultNotes,
  StyledCvsResultTable,
  StyledDialogBody,
  StyledDialogHeader,
  StyledDialogHeaderText,
} from './index.style'

interface Props {
  onClose: () => void
  cvsResult?: CvsResult
  purchaserPurchasedItemId?: string | number
}

const ConfirmCvsInfo = ({ onClose, cvsResult, purchaserPurchasedItemId }: Props) => {
  const [cvsInfo, setCvsInfo] = useState<CvsResult>()
  const [paymentTerm, setPaymentTerm] = useState('')

  const setDisplayDate = (date: string) => {
    const newDate = new Date(date)
    setPaymentTerm(`${newDate.getFullYear()}年${newDate.getMonth() + 1}月${newDate.getDate()}日`)
  }

  const cvsUrl = (convenience: string | undefined) => {
    switch (convenience) {
      case 'ローソン':
        return 'https://static.mul-pay.jp/customer-convenience-store/lawson/14.html'
      case 'ファミリーマート':
        return 'https://www.family.co.jp/services/application/receipt.html'
      case 'セイコーマート':
        return 'https://www.econtext.jp/support/cvs/seicomart.html'
      case 'ミニストップ':
        return 'https://www.econtext.jp/support/cvs/lawson.html'
    }
  }

  useEffect(() => {
    const getCvsInfo = async () => {
      const result = await getCvsPurchaseInfo({
        purchaser_purchased_item_id: purchaserPurchasedItemId,
      })
      setDisplayDate(result.data?.payment_term)
      setCvsInfo(result.data)
    }

    if (cvsResult) {
      setDisplayDate(cvsResult?.payment_term)
      setCvsInfo(cvsResult)
      return
    } else if (purchaserPurchasedItemId) {
      getCvsInfo()
      return
    }
  }, [cvsResult, purchaserPurchasedItemId])

  const renderHeader = () => (
    <StyledDialogHeader>
      <StyledArrowBackIcon></StyledArrowBackIcon>
      <StyledDialogHeaderText>コンビニ決済</StyledDialogHeaderText>
      <StyledCloseIcon>
        <CloseIcon fill={Colors.BLACK} width={16} height={16} onClick={onClose} />
      </StyledCloseIcon>
    </StyledDialogHeader>
  )

  const renderContent = () => (
    <StyledDialogBody>
      <StyledCvsResultContainer>
        <StyledCvsResultMessage>{cvsResult && '申し込みが完了しました。'}</StyledCvsResultMessage>
        <StyledCvsResultNotes>
          ※こちらの画面はスクリーンショットをして
          <br />
          保管することをおすすめします。
        </StyledCvsResultNotes>
        <StyledCvsResultTable>
          <tr>
            <th>コンビニ</th>
            <td>{cvsInfo?.convenience}</td>
          </tr>
          <tr>
            <th>支払い期限</th>
            <td>{paymentTerm}</td>
          </tr>
          {cvsInfo?.convenience === 'ファミリーマート' ? (
            <>
              <tr>
                <th>第1番号</th>
                <td className="number">{cvsInfo?.conf_no}</td>
              </tr>
              <tr>
                <th>第2番号</th>
                <td className="number">{cvsInfo?.receipt_no}</td>
              </tr>
            </>
          ) : (
            <>
              <tr>
                <th>受付番号</th>
                <td className="number">{cvsInfo?.receipt_no}</td>
              </tr>
              <tr>
                <th>確認番号</th>
                <td className="number">{cvsInfo?.conf_no}</td>
              </tr>
            </>
          )}
          <tr>
            <th>振込表URL</th>
            <td>
              {cvsInfo?.receipt_url === 'null' || !cvsInfo?.receipt_url ? (
                <>-</>
              ) : (
                <Link href={cvsInfo.receipt_url} target="_blank">
                  {cvsInfo?.receipt_url}
                </Link>
              )}
            </td>
          </tr>
        </StyledCvsResultTable>
        <StyledCvsResultMessage>
          コンビニ決済のやり方は
          <a href={cvsUrl(cvsInfo?.convenience)} target="_blank" rel="noreferrer">
            こちら
          </a>
        </StyledCvsResultMessage>
      </StyledCvsResultContainer>
    </StyledDialogBody>
  )

  return (
    <>
      <HalfModal header={renderHeader()} content={renderContent()} top={46}></HalfModal>
    </>
  )
}

export default ConfirmCvsInfo
